import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles, useTheme } from '@material-ui/core/styles'

import {
  Grid,
  Typography
} from '@material-ui/core'

import * as Brands from '~/assets/images/logo/brands'
import Menu from '~/components/menu'

import CloseIcon from '@material-ui/icons/Close'

export default () => {
  const classes = useStyles()
  const theme = useTheme()

  const { REACT_APP_BRANCH } = window?.env || {}

  const logoColor = theme.palette?.inverse ? theme.palette.primary.main : theme.palette.background.paper

  const { store } = useSelector(state => state.storeReducers)
  const { webview } = useSelector(state => state.configReducers.configs)

  const RenderStoreCampaignInfos = () => {
    if (!store?.storeName) {
      return ''
    }

    return (
      <Grid item>
        <Grid container direction='row' wrap='nowrap' justify='center'>
          <Grid item>
            <Typography variant='caption' align='center'>
              {store?.storeName}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid container direction='column' wrap='nowrap' className={classes.BASE} spacing={2}>
      {webview && (
        <CloseIcon
          className={classes.CLOSE}
          onClick={() => {
            if (typeof window?.Native?.close === 'function') {
              window.Native.close()
            } else {
              window.open('', '_self', '')
              window.close()
            }
          }}
        />
      )}
      <Grid item xs={12} className={classes.LOGO}>
        <Grid container direction='column' wrap='nowrap' spacing={2}>
          <Grid item>
            <Grid container direction='row' wrap='nowrap' justify='center'>
              <Grid item>
                {Brands[REACT_APP_BRANCH] ? Brands[REACT_APP_BRANCH](logoColor) : Brands.BOT(logoColor)}
              </Grid>
            </Grid>
          </Grid>
          <RenderStoreCampaignInfos />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Menu mobile />
      </Grid>
    </Grid>
  )
}

const useStyles = makeStyles((theme) => ({
  BASE: {
    ...(
      theme.palette?.inverse ? (
        {
          background: theme.palette.secondary.main,
          color: theme.palette.primary.main
        }
      ) : (
        {
          background: theme.palette.primary.main,
          color: theme.palette.background.paper
        }
      )
    ),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    position: 'relative'
  },
  CLOSE: {
    position: 'absolute',
    color: theme.palette.background.paper,
    top: 19,
    right: 19,
    zIndex: 999
  },
  LOGO: {
    position: 'relative',
    '& svg': {
      height: '20px',
      width: 'auto',
      maxWidth: '100%',
      display: 'block'
    }
  }
}))
